import styled from "styled-components";
import { palette } from "styled-theme";
import { withFilteredProps } from '@components/withFilteredProps/withFilteredProps';

const shouldForwardProp = (prop) => !['removeOutline'].includes(prop);

const _anchorLink = styled.a.attrs(({rel="noopener noreferrer", target="_blank"}) => ({
  rel,
  target,
}))`
  text-align: left;
  text-decoration: none;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  user-select: text;
  -moz-user-select: text;
  cursor: pointer;
  outline: none;
  font-size: 15px;
  word-break: normal;
  ${props => props.removeOutline ? "outline: none" : ""}
  
  &:disabled {
    cursor: default;
  }
`;

export const anchorLink = withFilteredProps(_anchorLink, shouldForwardProp);

export const AnchorLink = styled(anchorLink)`
  color:${palette("link", 1)};
  text-decoration: underline;
  
  &:hover {
    color:${palette("link", 0)};
    text-decoration: none;
  }
`;